export const IMAGES = 'assets/img/';
export const SVGS = 'assets/svg/';
